import {FormControl, FormControlLabel, FormGroup, FormHelperText, Grid} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import {GridSize} from '@mui/material/Grid/Grid';
import {Theme} from '@mui/material/styles';
import {SxProps} from '@mui/system';
import React, {PropsWithChildren, ReactNode} from 'react';
import {Controller, FieldPath, useFormContext} from 'react-hook-form';
import {FieldValues} from 'react-hook-form/dist/types';
import {getErrorLabel} from './useAppForm';
import {fieldPathToId, markLabelAsMandatory} from './utils';
import {InfoIconPopover} from './InfoIconPopover';

interface AppCheckboxFieldProps<TFieldValues extends FieldValues = FieldValues> {
    fieldPath: FieldPath<TFieldValues>;
    label: string;
    infoPopoverText?: string | ReactNode;
    breakpoint?: boolean | GridSize;
    helperText?: React.ReactNode;
    sx?: SxProps<Theme>;
    required?: boolean;
    readOnly?: boolean;
}

export function AppCheckboxField<TFieldValues extends FieldValues = FieldValues>(props: PropsWithChildren<AppCheckboxFieldProps<TFieldValues>>) {
    const {control} = useFormContext();

    return (
            <Grid item xs={props.breakpoint}>
                <Controller control={control}
                            name={props.fieldPath}
                            render={({field, fieldState: {error}}) => {
                                const hasError = error !== undefined;
                                return (<FormControl
                                        error={hasError}
                                        component="fieldset"
                                        variant="standard"
                                        sx={props.sx ?? {marginTop: '24px'}}
                                >
                                    <FormGroup>
                                        <FormControlLabel label={<>
                                            {markLabelAsMandatory(props.label, props.required)}
                                            {props.infoPopoverText &&
                                                    <InfoIconPopover content={props.infoPopoverText}/>}
                                        </>}
                                                          control={
                                                              <Checkbox {...field}
                                                                        disabled={props.readOnly}
                                                                        id={fieldPathToId(props.fieldPath)}
                                                                        ref={undefined}
                                                                        inputRef={field.ref}
                                                                        checked={field.value ?? false}
                                                                        inputProps={{'aria-invalid': hasError}}
                                                                        onChange={(event, checked) => {
                                                                            field.onChange(checked);
                                                                            field.onBlur();
                                                                        }}
                                                              />
                                                          }/>
                                        {(hasError || props.helperText !== undefined) &&
                                                <FormHelperText>{hasError ? getErrorLabel(error) : props.helperText}</FormHelperText>}
                                    </FormGroup>
                                </FormControl>);
                            }}/>
            </Grid>
    );
}
